import React, { useState } from "react";
import FsLightbox from "fslightbox-react";
import "../../../App.css"
import image1 from "../../../Img/Proyectos/ProyectosIyC/G7TV/61cd283c29c4f98433c8974c_Toros.TorreVieja.4.jpg"
import image2 from "../../../Img/Proyectos/ProyectosIyC/G7TV/61cd285827c4ed65b603bde8_Toros.TorreVieja.2.jpg"
import image3 from "../../../Img/Proyectos/ProyectosIyC/G7TV/61cd2886caa266e946b5acaa_Toros.TorreVieja.1.jpg"
import image4 from "../../../Img/Proyectos/ProyectosIyC/G7TV/61cd288abaf02f547e9c62c7_Toros.TorreVieja.3.jpg"
import image5 from "../../../Img/Proyectos/ProyectosIyC/G7TV/61cd28912486cd2302592de3_Toros.TorreVieja.7.jpg"
import image6 from "../../../Img/Proyectos/ProyectosIyC/G7TV/61cd28912486cddf24592de2_Toros.TorreVieja.8.jpg"
import image7 from "../../../Img/Proyectos/ProyectosIyC/G7TV/61cd289129c4f922ccc89837_Toros.TorreVieja.10.jpg"
import image8 from "../../../Img/Proyectos/ProyectosIyC/G7TV/61cd2891ed503d000a167063_Toros.TorreVieja.9.jpg"
import image9 from "../../../Img/Proyectos/ProyectosIyC/G7TV/61cd289283221769fc18c4f1_Toros.TorreVieja.5.jpg"

function ProyectoG7TV() {



    const [toggler, setToggler] = useState(false);

    const [lightboxController, setLightboxController] = useState({
        toggler: false,
        slide: 1
    });

    function openLightboxOnSlide(number) {
        setLightboxController({
            toggler: !lightboxController.toggler,
            slide: number
        });
    }


    return (
        <>
            <FsLightbox
                toggler={lightboxController.toggler}

                sources={[
                    image1, image2, image3, image4, image5, image6, image7, image8, image9
                ]}

                slide={lightboxController.slide}
            />

            <div className="container col-12 py-5">
                <div className="d-flex">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/proyectos-en-desarrollo">Varios</a></li>
                            <li class="breadcrumb-item active" aria-current="page">Ganadería "El 7" Torre Vieja</li>
                        </ol>
                    </nav>
                </div>
                <h1 className="py-2 m-0 p-0">Ganadería "El 7" Torre Vieja</h1>
                <h6 className="py-2 m-0 p-0">Zapopan, Jal.<h6>2004</h6></h6>
            </div>

            <div className="container position-relative">
                <img onClick={() => openLightboxOnSlide(1)} type="button" src={image1} className="w-100" alt="..." height={650} />
            </div>


            <div className="container">
                <div className="row gy-4 mt-1">

                    <div className="col-lg-4 col-md-12">
                        <img onClick={() => openLightboxOnSlide(2)}
                            src={image2}
                            className="w-100 h-100"
                            alt="imagen proyecto"
                        />
                    </div>

                    <div className="col-lg-4 col-md-12">
                        <img onClick={() => openLightboxOnSlide(3)}
                            src={image3}
                            className="w-100 h-100"
                            alt="imagen proyecto"
                        />
                    </div>

                    <div className="col-lg-4 col-md-12">
                        <img onClick={() => openLightboxOnSlide(4)}
                            src={image4}
                            className="w-100 h-100"
                            alt="imagen proyecto"
                        />
                    </div>

                    <div className="col-lg-4 col-md-12">
                        <img onClick={() => openLightboxOnSlide(5)}
                            src={image5}
                            className="w-100 h-100"
                            alt="imagen proyecto"
                        />
                    </div>

                    <div className="col-lg-4 col-md-12">
                        <img onClick={() => openLightboxOnSlide(6)}
                            src={image6}
                            className="w-100 h-100"
                            alt="imagen proyecto"
                        />
                    </div>

                    <div className="col-lg-4 col-md-12">
                        <img onClick={() => openLightboxOnSlide(7)}
                            src={image7}
                            className="w-100 h-100"
                            alt="imagen proyecto"
                        />
                    </div>

                    <div className="col-lg-4 col-md-12">
                        <img onClick={() => openLightboxOnSlide(8)}
                            src={image8}
                            className="w-100 h-100"
                            alt="imagen proyecto"
                        />
                    </div>

                    <div className="col-lg-4 col-md-12">
                        <img onClick={() => openLightboxOnSlide(9)}
                            src={image9}
                            className="w-100 h-100"
                            alt="imagen proyecto"
                        />
                    </div>

                </div>
            </div>
        </>
    );
}

export default ProyectoG7TV;
